import { render, staticRenderFns } from "./qa.vue?vue&type=template&id=8cd63ab6&scoped=true&"
import script from "./qa.vue?vue&type=script&lang=js&"
export * from "./qa.vue?vue&type=script&lang=js&"
import style0 from "./qa.vue?vue&type=style&index=0&id=8cd63ab6&prod&scoped=true&lang=scss&"
import style1 from "./qa.vue?vue&type=style&index=1&id=8cd63ab6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd63ab6",
  null
  
)

export default component.exports